import { render, staticRenderFns } from "./ViewHeaderSidebar.vue?vue&type=template&id=2aa77072&"
import script from "./ViewHeaderSidebar.vue?vue&type=script&lang=js&"
export * from "./ViewHeaderSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports